
import { createMuiTheme } from '@material-ui/core/styles';

import { ThemeColors } from './theme';
import { white } from 'material-ui/styles/colors';

// export const getTheme = getMuiTheme({
//   palette: {
//     alternateTextColor: '#333333',
//     primary1Color: ThemeColors.primary1Color, //#28a9e0
//     accent1Color: ThemeColors.accent1Color, //#8dc043
//     accent2Color: ThemeColors.accent2Color,
//     noProgressBgColor: ThemeColors.noProgressBgColor || ThemeColors.accent2Color,
//     progressBgColor: ThemeColors.progressbarColor,
//     fullProgressbarColor: ThemeColors.fullProgressbarColor || ThemeColors.accent1Color,
//     positiveColor: ThemeColors.positiveColor || '#7ec320',
//     negativeColor: ThemeColors.negativeColor || '#f80013',
//     primary2Color: ThemeColors.primary1Color,
//   },
// });

// export const getTheme2 = getMuiTheme({
//   palette: {
//     alternateTextColor: '#333333',
//     primary1Color: '#333333', //#28a9e0
//     accent1Color: ThemeColors.accent1Color, //#8dc043
//     accent2Color: ThemeColors.accent2Color,
//     noProgressBgColor: ThemeColors.noProgressBgColor || ThemeColors.accent2Color,
//     progressBgColor: ThemeColors.progressbarColor,
//     fullProgressbarColor: ThemeColors.fullProgressbarColor || ThemeColors.accent1Color,
//     positiveColor: ThemeColors.positiveColor || '#7ec320',
//     negativeColor: ThemeColors.negativeColor || '#f80013',
//     primary2Color: ThemeColors.primary1Color,
//   },
// });

const theme = createMuiTheme({
  typography: {
    htmlFontSize: 12,
    useNextVariants: true,
    fontFamily: 'Montserrat, sans-serif',
    color: '#707070',
    h1: {
      fontSize: 16,
      color: ThemeColors.primary1Color,
      fontWeight: 'bold',
      padding: '15px 0 5px 0',
      textTransform: 'none',
    },
    h2: {
      fontSize: 16,
      color: '#707070',
    },
    h3: {
      fontSize: 14,
      color: '#707070',
    },
    h4: {
      fontSize: 12,
      color: '#707070',
    },
    body1: {
      fontSize: 12,
    },
    body2: {
      fontSize: 14,
    },
  },
  palette: {
    primary: { main: ThemeColors.primary1Color },
    secondary: { main: ThemeColors.accent1Color },
    textOnBackground: ThemeColors.darkTextOnPrimaryBackground ? 'black' : white,
    textColor: '#707070',
    primary1Color: ThemeColors.primary1Color, // #28a9e0
    primary2Color: ThemeColors.primary1Color,
    accent1Color: ThemeColors.accent1Color,
    lineColor: 'lightgrey',
    noProgressBgColor: ThemeColors.noProgressBgColor || ThemeColors.accent2Color,
    progressBgColor: ThemeColors.progressBgColor || ThemeColors.progressbarColor,
    fullProgressbarColor: ThemeColors.fullProgressbarColor || ThemeColors.accent1Color,
    positiveColor: ThemeColors.positiveColor || '#7ec320',
    negativeColor: ThemeColors.negativeColor || '#f80013',
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/app/app.theme.js